import _ from 'lodash'
import $ from 'jquery'
import eventManager from 'eventmanager'
import siteConfig from '../abt-core/site-config.json'

var mod = {}

/**
 * Gets the value of the specified cookie.
 * @param {string} name - the name of the cookie to get.
 * @returns {string} - the decoded cookie value (or undefined if it doesn't exist).
 */
mod.get = function get (name) {
  var cookies = document.cookie.split(';')
  var cookie = _.find(cookies, function (cookie) {
    return $.trim(cookie).indexOf(name + '=') === 0
  })
  return cookie && mod._decode(cookie)
}

/**
 * Sets a cookie.
 * @param {string} name - the name of the cookie to set.
 * @param {string} value - the value to set for the cookie.
 * @param {Date} expiration - the cookie expiration date.
 * @returns {string} value - the cookie value.
 */
mod.set = function set (name, value, expiration) {
  var data = name + '=' + window.encodeURIComponent(value)
  var expires = 'expires=' + expiration.toGMTString()
  var domain = 'domain=' + siteConfig.cookies.domain
  var path = 'path=/;'

  document.cookie = [data, expires, domain, path].join(';')
  eventManager.log('ABT: set cookie [' + name + '=' + value + ']')

  return value
}

/**
 * Decodes the cookie value string.
 * @param {string} cookie - the cookie to decode.
 * @returns {string} - the decoded cookie value.
 */
mod._decode = function _decode (cookie) {
  return window.decodeURIComponent(_.last(cookie.split('=')))
}

export default mod



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-utils/cookies.js
 ** module id = 4
 ** module chunks = 2 3
 **/